/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_Default_DescriptionInputs */

const en_cta_default_description = /** @type {(inputs: Cta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speak with our team about market entry, business planning, setup coordination, and the next practical steps for your U.S. operations.`)
};

const pt_cta_default_description = /** @type {(inputs: Cta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fale com nossa equipe sobre entrada no mercado, planejamento empresarial, coordenação da implantação e os próximos passos práticos para suas operações nos EUA.`)
};

const es_cta_default_description = /** @type {(inputs: Cta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hable con nuestro equipo sobre entrada al mercado, planificación empresarial, coordinación de la puesta en marcha y los próximos pasos prácticos para sus operaciones en EE. UU.`)
};

/**
* | output |
* | --- |
* | "Speak with our team about market entry, business planning, setup coordination, and the next practical steps for your U.S. operations." |
*
* @param {Cta_Default_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const cta_default_description = /** @type {((inputs?: Cta_Default_DescriptionInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_Default_DescriptionInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_cta_default_description(inputs)
	if (locale === "es") return es_cta_default_description(inputs)
	return en_cta_default_description(inputs)
});